import { Component } from 'react';
import { isTestEnv } from '../../../../../devOpsHelper/DevOps';
import styles from './ConfirmAction.module.css';

export class ConfirmAction extends Component {
    UNSAFE_componentWillMount() {
        if (!isTestEnv()) {
            this.setState({ disableInput: true });
            setTimeout(() => {
                this.setState({ disableInput: false });
            }, 500);
        } else {
            this.setState({ disableInput: false });
        }
    }

    handleClick = () => {
        const { onSubmit } = this.props;

        onSubmit();
    };

    render() {
        const { children, ...otherProps } = this.props;

        return (
            <button
                disabled={this.state.disableInput}
                className={styles.ConfirmAction}
                onClick={this.handleClick}
                {...otherProps}
            >
                {children}
            </button>
        );
    }
}
